import { apiRequest } from '@/api/client';
import type { EnqueueResult, ImportSiteRequest } from '@/types/api';

/** Bringing an existing WordPress under management (P7). */
export const importsApi = {
  start: (input: ImportSiteRequest, key: string) =>
    apiRequest<EnqueueResult & { siteId: string }>('/sites/import', { method: 'POST', body: input, idempotencyKey: key }),

  /** The command for the old server: one upload, valid for a day. */
  issueToken: (id: string) =>
    apiRequest<{ command: string; scriptUrl: string; expiresAt: string }>(`/sites/${id}/import/token`, {
      method: 'POST',
      body: {},
    }),

  switchNames: (id: string, confirmation: string, key: string) =>
    apiRequest<EnqueueResult>(`/sites/${id}/import/switch`, { method: 'POST', body: { confirmation }, idempotencyKey: key }),

  rollback: (id: string, confirmation: string, key: string) =>
    apiRequest<EnqueueResult>(`/sites/${id}/import/rollback`, { method: 'POST', body: { confirmation }, idempotencyKey: key }),
};
